// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';

import {
  SpOperationalState,
  SpOperationalStateColor,
} from '../enum/spare-parts-enums';

@Injectable({
  providedIn: 'root',
})
export class StatusColorService {
  public statusColor(
    status: Readonly<SpOperationalState> | null | undefined,
  ): string {
    let color = '';
    switch (status) {
      case SpOperationalState.NoImpact:
        color = SpOperationalStateColor.Green;
        break;
      case SpOperationalState.PartiallyDown:
        color = SpOperationalStateColor.Yellow;
        break;
      case SpOperationalState.TotalDown:
        color = SpOperationalStateColor.Red;
        break;
      default:
        color = SpOperationalStateColor.Grey;
    }

    return color;
  }
}
